import { FaCheck } from 'react-icons/fa6'

const plans = [
  {
    name: 'Basic',
    price: '100.000',
    desc: 'Cocok untuk RT/RW Net skala kecil',
    features: [
      'Hingga 50 Pelanggan',
      '1 Mikrotik Terhubung',
      'Billing Otomatis',
      'Dashboard Dasar',
      'Notifikasi Email',
      'Support Chat',
    ],
    popular: false,
  },
  {
    name: 'Advance',
    price: '250.000',
    desc: 'Untuk bisnis yang mulai berkembang',
    features: [
      'Hingga 250 Pelanggan',
      '2 Mikrotik Terhubung',
      'Auto Isolir Dasar',
      'Dashboard Analitik',
      'Notifikasi WhatsApp',
      'Laporan Keuangan',
      'Support Email & Chat',
    ],
    popular: false,
  },
  {
    name: 'Professional',
    price: '450.000',
    desc: 'Solusi standar untuk ISP modern',
    features: [
      'Hingga 500 Pelanggan',
      '5 Mikrotik Terhubung',
      'Auto Isolir Cerdas',
      'Dashboard Analitik Lengkap',
      'Notifikasi WhatsApp',
      'Laporan Keuangan & Pajak',
      'API Akses',
      'Priority Support',
    ],
    popular: true,
  },
  {
    name: 'Enterprise',
    price: '850.000',
    desc: 'Solusi lengkap tanpa batas',
    features: [
      'Pelanggan Unlimited',
      'Mikrotik Unlimited',
      'Semua Fitur Professional',
      'Multi-Admin & Role',
      'White Label Branding',
      'Dedicated Account Manager',
      'SLA 99.9%',
      'Custom Integration',
    ],
    popular: false,
  },
]

export default function LpPricingSection() {
  return (
    <section
      id="harga"
      className="relative py-24 lg:py-32 grid-bg"
      aria-labelledby="harga-heading"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-16 reveal">
          <span className="text-ocean-600 font-semibold text-sm tracking-wider uppercase mb-4 block">
            Paket Harga
          </span>
          <h2
            id="harga-heading"
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight mb-6"
          >
            Harga Transparan,{' '}
            <span className="gradient-text">Tanpa Biaya Tersembunyi</span>
          </h2>
          <p className="text-slate-custom text-lg leading-relaxed">
            Pilih paket sesuai skala bisnis Anda. Upgrade atau downgrade kapan
            saja tanpa penalti.
          </p>
        </div>

        {/* 
           Diubah grid dari md:grid-cols-3 menjadi md:grid-cols-2 lg:grid-cols-4 
           agar muat untuk 4 paket. Max-width juga diperlebar sedikit. 
        */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {plans.map((p, i) => (
            <article
              key={i}
              className={`rounded-2xl p-7 reveal flex flex-col ${
                p.popular ? 'pricing-popular card-glow' : 'card-glow'
              }`}
              style={{ transitionDelay: i * 0.1 + 's' }}
            >
              <div>
                <h3 className="font-display font-bold text-xl text-white mb-2">
                  {p.name}
                </h3>
                <p className="text-slate-custom text-sm mb-6">{p.desc}</p>
                <div className="mb-6">
                  <span className="text-slate-custom text-sm">Rp</span>
                  <span className="font-display text-4xl font-bold text-white mx-1">
                    {p.price.toLocaleString('id-ID')}
                  </span>
                  <span className="text-slate-custom text-sm">/bulan</span>
                </div>
                <ul className="space-y-3 mb-8">
                  {p.features.map((f, j) => (
                    <li key={j} className="flex items-start gap-2.5 text-sm">
                      <FaCheck
                        className={`text-xs mt-1 ${
                          p.popular ? 'text-ocean-400' : 'text-ocean-700'
                        }`}
                      />
                      <span className="text-slate-custom">{f}</span>
                    </li>
                  ))}
                </ul>
              </div>
              
              <a
                href="#kontak"
                className={`block text-center rounded-xl py-3.5 font-semibold text-sm transition-all duration-300 mt-auto ${
                  p.popular
                    ? 'btn-primary justify-center'
                    : 'btn-secondary justify-center border-navy-500/40 text-slate-custom hover:text-ocean-500'
                }`}
              >
                Mulai Sekarang
              </a>
            </article>
          ))}
        </div>

        <p className="text-center text-slate-custom text-sm mt-10 reveal">
          Semua paket sudah termasuk uji coba gratis 14 hari. Tidak perlu kartu
          kredit.
        </p>
      </div>
    </section>
  )
}